/**
 * 
 *   Usage: See clsList for examples, API and implementation notes. 
 * 
 */
import clsList from '@cls/clsList'

// 
// categories are fixed within the system. 
// See documentation in the backend. There is just no use to make something special for this,  
// to make this more flexible or whatever. It is only used in this specific file to filter the list of activity types.
// 
const CATEGORY = {
    PROJECT: 1,
    HOLIDAY: 2,
    ABSENCE: 3,
}
 
class clsActivityType extends clsList {
 
     /**
     * Activity types of category project
     */
    get project() {
        return this.list.filter( (v) => v.id_category == CATEGORY.PROJECT);
    }
     /**
     * Activity types of category holiday
     */
    get holiday() {
        return this.list.filter( (v) => v.id_category == CATEGORY.HOLIDAY);
    }
    /**
     * Activity types of category absence
     */
    get absence() {
        return this.list.filter( (v) => v.id_category == CATEGORY.ABSENCE);
    }

 }
 
export default clsActivityType
